import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69b78088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "【重要】Amazon連携注意事項", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ★店舗連携を行うため、お客様の端末で運営するAmazonセラーアカウントへログインが必要ですので、通常AmazonセラーアカウントログインのIPアドレスで操作してください。 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ★店舗連携際に、Amazon公式ウェブサイトに移行しますので、安全のため複数アカウントの場合同一IPアドレスで連携操作をしないことをお勧め致します） ", -1))
const _hoisted_5 = { class: "text-rt" }


import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  emits: ['close', 'ok'],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, _mergeProps({ "model-value": true }, _ctx.$attrs, {
    width: "600px",
    onClosed: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_scrollbar, {
          class: "text",
          height: "300px"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('ok'))),
            style: {"width":"100px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('同意')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 16))
}
}

})